export default () => {
    let scrollable = document.getElementById('scrollable');

    let scrollTabs = function(el, to, duration) {
        const
            element = el,
            start = element.scrollLeft,
            change = to - start,
            startDate = +new Date(),
            // t = current time
            // b = start value
            // c = change in value
            // d = duration
            easeInOutQuad = function(t, b, c, d) {
                t /= d/2;
                if (t < 1) return c/2*t*t + b;
                t--;
                return -c/2 * (t*(t-2) - 1) + b;
            },
            animateScroll = function() {
                const currentDate = +new Date();
                const currentTime = currentDate - startDate;
                element.scrollLeft = parseInt(easeInOutQuad(currentTime, start, change, duration));
                if(currentTime < duration) {
                requestAnimationFrame(animateScroll);
                }
                else {
                element.scrollLeft = to;
                }
            };
        animateScroll();
    };

    let checkScroll = function(el) {
        if (scrollable.offsetWidth < jQuery(el).parents('ul')[0].offsetWidth) {
            if (el.offsetLeft < scrollable.scrollLeft) { //scrolling to the left
                scrollTabs(scrollable, el.offsetLeft - 16, 150);
            } else if ((el.offsetLeft + el.offsetWidth) > (scrollable.scrollLeft + scrollable.offsetWidth)) { // scrolling to the right
                let distance = (el.offsetLeft + el.offsetWidth + 16 + 24) - scrollable.offsetWidth;
                scrollTabs(scrollable, distance, 150);
            }
        }
    }

    jQuery('#scrollable li').on('click', function() {
        checkScroll(this);
    });

    UIkit.util.on('.js-scrollable', 'active', function () {
        let element = jQuery(this).find('li.uk-active')[0];
        checkScroll(element);
    });
}
